// Blog article (sections/article.liquid): table of contents from the article's h2 headings with scroll-spy
// (desktop sidebar + phone pill with a progress ring), reading progress bar along the top edge.

const root = document.querySelector('[data-article]')
if (root) {
  const body = root.querySelector('[data-article-body]')
  const heads = [...body.querySelectorAll('h2')].filter((h) => h.textContent.trim())
  const lists = [...document.querySelectorAll('[data-toc-list]')]
  const sidebar = root.querySelector('[data-toc]')
  const pill = document.querySelector('[data-toc-pill]')
  const bar = root.querySelector('[data-progress]')
  const ring = pill?.querySelector('[data-ring]')
  const current = pill?.querySelector('[data-toc-current]')
  const sheet = pill?.querySelector('#TocSheet')
  const openBtn = pill?.querySelector('[data-toc-open]')
  const slug = (s) => s.toLowerCase().normalize('NFKD').replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '-').slice(0, 60)

  // ---------- table of contents (only worth it with 3+ headings) ----------
  if (heads.length >= 3) {
    heads.forEach((h, i) => (h.id ||= `${slug(h.textContent) || 'abschnitt'}-${i + 1}`))
    for (const ol of lists) ol.innerHTML = heads.map((h) => `<li><a class="toc-link" href="#${h.id}" data-toc-link="${h.id}">${h.textContent.trim()}</a></li>`).join('')
    sidebar.hidden = false
    pill.hidden = false
    document.body.append(pill) // fixed, above the footer

    const links = [...document.querySelectorAll('[data-toc-link]')]
    const mark = (id) => {
      links.forEach((a) => a.toggleAttribute('aria-current', a.dataset.tocLink === id))
      const h = heads.find((x) => x.id === id)
      if (h && current) current.textContent = h.textContent.trim()
    }
    const io = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && mark(e.target.id)), { rootMargin: '-30% 0px -60% 0px' })
    heads.forEach((h) => io.observe(h))

    document.addEventListener('click', (e) => {
      const a = e.target.closest('[data-toc-link]')
      if (!a) return
      e.preventDefault()
      const h = document.getElementById(a.dataset.tocLink)
      const lenis = window.janado?.lenis
      lenis ? lenis.scrollTo(h, { offset: -(parseFloat(getComputedStyle(h).scrollMarginTop) || 0) }) : h.scrollIntoView({ behavior: 'smooth' })
      history.replaceState(null, '', `#${h.id}`)
      toggle(false)
    })
  }

  // ---------- phone pill opens the list ----------
  const toggle = (on) => {
    if (!sheet) return
    sheet.hidden = !on
    openBtn.setAttribute('aria-expanded', String(on))
  }
  openBtn?.addEventListener('click', () => toggle(sheet.hidden))
  document.addEventListener('click', (e) => sheet && !sheet.hidden && !pill.contains(e.target) && toggle(false))
  document.addEventListener('keydown', (e) => e.key === 'Escape' && toggle(false))

  // ---------- reading progress: bar on top, ring in the pill ----------
  let ticking = false
  const update = () => {
    ticking = false
    const r = body.getBoundingClientRect()
    const p = Math.min(1, Math.max(0, (innerHeight * 0.4 - r.top) / r.height))
    if (bar) bar.style.transform = `scaleX(${p})`
    if (ring) ring.style.strokeDashoffset = String(62.83 * (1 - p))
    // the pill only shows while you're in the article
    if (pill && !pill.hidden) pill.style.visibility = r.top < innerHeight * 0.5 && r.bottom > innerHeight * 0.4 ? 'visible' : 'hidden'
  }
  addEventListener('scroll', () => ticking || ((ticking = true), requestAnimationFrame(update)), { passive: true })
  update()
}
